import React, { useEffect } from 'react';
import { PromoManager } from './PromoManager';
import { useData } from '../../../data-layer';
import { LayoutType } from '../../../API';

export function Promotions(): React.ReactElement {
  const { plans, coupons, pages, audiences } = useData();

  // Promotions themselves are fetched a filtered page at a time by PromoManager.
  // These four resolve what the page renders around them: PlanBadge and
  // CouponBadge look up codes that are not necessarily on the visible page, and
  // PromoForm reads audiences, plan groups and promo template ids.
  useEffect(() => {
    plans.hook.getAll();
    coupons.hook.getAll();
    pages.hook.getBucket(LayoutType.PROMOS);
    audiences.hook.getAll();
  }, []);

  return <PromoManager />;
}
